import { allPass, any, find, last, pathSatisfies, pipe, propEq } from 'ramda';
import { isTruthy } from 'ramda-adjunct';
import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { SystemFolderId } from '../../../../constants/SystemFolderId';
import { getId } from '../../../../utils/common';
import { MediaManagerSDKAnyItem, MediaManagerSDKFolder } from '../../../../utils/media-manager-sdk';
import {
  decodeWixSiteFolderId,
  isSystemFolder,
  isWixSiteFolder,
  TDecodedWixSiteFileFolderId,
} from '../../../../utils/media-manager-sdk/items';

export const isInsideWixVideoLibrary = pipe<
  MediaManagerSDKFolder[],
  MediaManagerSDKFolder,
  string,
  TDecodedWixSiteFileFolderId,
  boolean
>(
  last,
  getId,
  decodeWixSiteFolderId,
  allPass([pathSatisfies(isTruthy, ['siteMediaToken']), propEq('id', SystemFolderId.WixVideoLink)]),
);

export const extractSiteFolder = find<MediaManagerSDKFolder>(
  pipe(
    getId,
    decodeWixSiteFolderId,
    allPass([pathSatisfies(isTruthy, ['siteMediaToken']), propEq('id', SystemFolderId.SiteFiles)]),
  ),
);

type TFooterMessageOptions = { rootFolderName?: string };
export const generateFooterMessage = (
  items: MediaManagerSDKAnyItem[],
  options?: TFooterMessageOptions,
): ReactElement => {
  if (any(isWixSiteFolder, items)) {
    return <FormattedMessage id="files-importer.select-files-message.no-sites-selection-allowed" />;
  }

  if (any(isSystemFolder, items)) {
    return <FormattedMessage id="files-importer.select-files-message.no-system-folders-selection-allowed" />;
  }

  return (
    <FormattedMessage
      id="files-importer.select-files-tooltip.no-folders-allowed-in-source"
      values={{ source: options.rootFolderName }}
    />
  );
};
